import { render, staticRenderFns } from "./OpenTokInStreamSetup.vue?vue&type=template&id=6d427eac&"
import script from "./OpenTokInStreamSetup.vue?vue&type=script&lang=js&"
export * from "./OpenTokInStreamSetup.vue?vue&type=script&lang=js&"
import style0 from "./OpenTokInStreamSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports